import { GetCommonCriteria } from './GetCommonCriteria';
import { GetCommonCriteriaVersion } from './GetCommonCriteriaVersion';
import { GetValidCriteriaName } from './GetValidCriteriaName';
import { ListCommonCriteria } from './ListCommonCriteria';
import { ListCommonCriteriaVersions } from './ListCommonCriteriaVersions';

/**
 * queries
 *
 * @type {{ListCommonCriteriaVersions: ((function({}=): Promise<*>)|*), GetCommonCriteria: ((function({}=):
 *     Promise<*>)|*), ListCommonCriteria: ((function({}=): Promise<*>)|*), GetCommonCriteriaVersion: ((function({}=):
 *     Promise<*>)|*), GetValidCriteriaName: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  GetCommonCriteria,
  GetCommonCriteriaVersion,
  GetValidCriteriaName,
  ListCommonCriteria,
  ListCommonCriteriaVersions,
};
